<template>
    <b-modal
        v-model="visible"
        @show="initModal"
        :id="modalId"
        :title="modalTitle"
    >
        <template v-if="!loading">
            <b-form-input
                v-model="role.name"
                required
                :state="state"
                placeholder="Choose a role name"
                @keyup="$emit('update:roleName', role.name)"
            >
            </b-form-input>
        </template>
        <template v-else> Loading ... </template>
        <template v-slot:modal-footer="{ cancel }">
            <b-button size="md" variant="outline-secondary" @click="cancel()">
                Cancel
            </b-button>
            <b-button size="md" variant="primary" @click="save">
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";

export default {
  name: "EditRole",
  props: {
    roleId: {
      type: Number,
      default: null
    },
    roleName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showModal: this.visible,
      role: {},
      state: null,
      loading: false,
      visible: false
    };
  },
  computed: {
    modalTitle() {
      return this.role.id !== undefined
        ? "Edit role: " + this.role.name
        : "Create new role";
    },
    modalId() {
      return this.roleId ? "role_edit_" + this.roleId : "role_edit_new";
    }
  },
  methods: {
    initModal() {
      if (this.roleId) {
        this.getRole();
      } else {
        this.role.name = null;
      }
    },
    getRole() {
      this.loading = true;
      axios
        .get("/api/roles/" + this.roleId)
        .then(r => {
          this.role = r.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.saving = true;
      let p;

      // Role name mandatory
      if (!this.role.name) {
        this.state = false;
        return;
      }

      if (this.roleId) {
        p = this.updateRole();
      } else {
        p = this.createRole();
      }

      p.finally(() => {
        this.$emit("saved");
        this.visible = false;
        this.state = true;
      });
    },
    createRole() {
      return axios.post("/api/roles", { name: this.role.name });
    },
    updateRole() {
      return axios.put("/api/roles/" + this.roleId, { name: this.role.name });
    }
  }
};
</script>

<style scoped>
</style>
